var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowCircleUpFilled = function SvgArrowCircleUpFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M12 2.25A9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25Zm-3.712 8.159a.75.75 0 0 0 1.06 1.06l1.902-1.901v6.675a.75.75 0 0 0 1.5 0V9.568l1.902 1.902a.75.75 0 0 0 1.06-1.061L12.53 7.227a.75.75 0 0 0-1.06 0l-3.182 3.182Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowCircleUpFilled);
export default ForwardRef;